import styled from 'styled-components';

const Wrapper = styled.div`
    display: flex;
    margin: 0px 5px;
    // padding: 5px;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    height: 24px;
    width: 24px;
    
    &.settings {
        background-color: #0000FF;
    }
    &.warning {
        // background-color: #F28041;
        color: #F28041;
        .icon {
            font-size: 18px;
        }
    }
    &.success {
        // background-color: #288500;
        color: #288500;
        .icon {
            font-size: 18px;
        }
    }

    .tip-icon {
        display: flex;
    }
    .tip-icon-show {
        animation:spin 0.5s linear 1;
        padding: 5px;
        margin-right: 5px;
    }
    .icon {
        width: 1rem;
        height: 1rem;
    }
    @keyframes spin { 100% { -webkit-transform: rotate(-160deg); transform:rotate(-160deg); } }
    
    &:hover {
        border-radius: 10px;
        color: #ffffff;
        font-size: 8px !important;
        overflow: hidden;
        width: 120px;
        height: 2rem;
        overflow-y: hidden;
        transition: width 0.05s linear;
        padding: 2px;
        &.success {
            color: #288500;
            width: 1.5rem;
            transition: none;
            .icon {
                font-size: 18px;
            }
        }
        &.warning {
            background-color: #F28041;
            .icon {
                font-size: 16px;
            }
        }
    }
`;

export default Wrapper;
